import { render, staticRenderFns } from "./VideoSearch.vue?vue&type=template&id=2ce05cf2&scoped=true&"
import script from "./VideoSearch.vue?vue&type=script&lang=js&"
export * from "./VideoSearch.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearch.vue?vue&type=style&index=0&id=2ce05cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce05cf2",
  null
  
)

export default component.exports